export default __webpack_public_path__ + "static/media/Snd_CB.c219129c.mp3";